// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

export const features = deepFreeze({
  accounting: {
    sidebar: true,
    settings: true,
    profile: true
  }
})

function deepFreeze<T>(obj: T): T {
  Object.keys(obj as object).forEach((key) => {
    const value = (obj as unknown as Record<string, unknown>)[key]
    if (typeof value === 'object' && value !== null) {
      deepFreeze(value)
    }
  })
  return Object.freeze(obj)
}
